






















































import Vue from 'vue';
import { Component, Prop } from 'vue-property-decorator';
import { mapGetters } from 'vuex';

import { LearningPathCourse } from 'frontend/store/modules/next-learning-path-course';
import ProgressBar from './ProgressBar.vue';
import { RelatedLearningPathInfo } from 'frontend/types/learningPathV2';
import LearningPathPill from 'frontend/views/learningPathV2/LearningPathPill.vue';
import CircleCheckMarkIcon from 'frontend/components/icons/CircleCheckMarkIcon.vue';

@Component({
  components: { CircleCheckMarkIcon, LearningPathPill, ProgressBar },
  computed: {
    ...mapGetters('pageHeader', ['isMobile']),
    ...mapGetters('relatedLearningPathInfo', ['learningPath']),
  },
})
export default class LLPDaisyChain extends Vue {
  @Prop({ type: Object, required: true })
  private nextLearningPathCourse!: LearningPathCourse;

  private learningPath!: RelatedLearningPathInfo;

  private get courseHref(): string {
    return `/courses/${this.nextLearningPathCourse.course.slug}/?from_llp=${this.learningPath.slug}`;
  }

  private get hasProgress(): boolean {
    return this.nextLearningPathCourse.course.percent_complete > 0;
  }

  private get percentComplete(): number {
    return this.nextLearningPathCourse.course.percent_complete / 100;
  }

  private get isCourseComplete(): boolean {
    return this.nextLearningPathCourse.course.percent_complete === 100;
  }

  private get learningPathForPill(): RelatedLearningPathInfo {
    return {
      ...this.learningPath,
      level_number: this.nextLearningPathCourse.level_number,
      level_highlighted_image_url: this.nextLearningPathCourse.level_highlighted_image_url,
    };
  }
}
